import { Component, input, ElementRef, ViewChild, AfterViewInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'lib-info-hover',
  imports: [],
  templateUrl: './info-hover.component.html',
  styleUrl: './info-hover.component.scss'
})
export class InfoHoverComponent implements AfterViewInit {
  content = input.required<string>();
  isHovered = false;

  @ViewChild('tooltipContent') tooltipContent!: ElementRef<HTMLDivElement>;
  @ViewChild('tooltipIcon', { read: ElementRef }) tooltipIcon!: ElementRef<HTMLElement>;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    // nothing needed here for now
  }

  onMouseEnter(event: MouseEvent) {
    this.isHovered = true;
    setTimeout(() => {
      if (!this.tooltipContent || !this.tooltipIcon) return;
      const iconRect = this.tooltipIcon.nativeElement.getBoundingClientRect();
      const tooltip = this.tooltipContent.nativeElement;
      const tooltipRect = tooltip.getBoundingClientRect();

      // Default below the icon, centered
      let top = iconRect.bottom + 8;
      let left = iconRect.left + iconRect.width / 2 - tooltipRect.width / 2;

      // Prevent overflow right
      if (left + tooltipRect.width > window.innerWidth - 8) {
        left = window.innerWidth - tooltipRect.width - 8;
      }
      // Prevent overflow left
      if (left < 8) {
        left = 8;
      }
      // Prevent overflow bottom
      if (top + tooltipRect.height > window.innerHeight - 8) {
        top = iconRect.top - tooltipRect.height - 8;
      }
      // Prevent overflow top
      if (top < 8) {
        top = 8;
      }

      this.renderer.setStyle(tooltip, 'top', `${top}px`);
      this.renderer.setStyle(tooltip, 'left', `${left}px`);
    });
  }

  onMouseLeave() {
    this.isHovered = false;
  }
}
